import React, { forwardRef } from 'react';

const OutputSamplesIcon = forwardRef((props, ref) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g clip-path="url(#clip0_23306_107418)">
        <path
          d="M11.9999 15.1667H8.66659V2.38203L11.5333 5.24869C11.659 5.37013 11.8274 5.43733 12.0022 5.43581C12.177 5.43429 12.3442 5.36418 12.4678 5.24057C12.5914 5.11697 12.6615 4.94976 12.663 4.77496C12.6646 4.60016 12.5974 4.43176 12.4759 4.30603L9.17859 1.0087C9.02382 0.853885 8.84007 0.73108 8.63783 0.647295C8.43559 0.56351 8.21883 0.520386 7.99993 0.520386C7.78102 0.520386 7.56426 0.56351 7.36202 0.647295C7.15978 0.73108 6.97603 0.853885 6.82126 1.0087L3.52126 4.30869C3.39625 4.43405 3.32617 4.60394 3.32642 4.78097C3.32667 4.958 3.39723 5.12769 3.52259 5.25269C3.64795 5.3777 3.81783 5.44779 3.99487 5.44754C4.1719 5.44729 4.34159 5.37672 4.46659 5.25136L7.33326 2.3847V15.1667H3.99993C3.82311 15.1667 3.65355 15.2369 3.52852 15.3619C3.4035 15.487 3.33326 15.6565 3.33326 15.8334C3.33326 16.0102 3.4035 16.1797 3.52852 16.3048C3.65355 16.4298 3.82311 16.5 3.99993 16.5H11.9999C12.1767 16.5 12.3463 16.4298 12.4713 16.3048C12.5964 16.1797 12.6666 16.0102 12.6666 15.8334C12.6666 15.6565 12.5964 15.487 12.4713 15.3619C12.3463 15.2369 12.1767 15.1667 11.9999 15.1667Z"
          fill="#031B4A"
        />
      </g>
      <defs>
        <clipPath id="clip0_23306_107418">
          <rect width="16" height="16" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default OutputSamplesIcon;
